import i18n from "@/plugins/vue-i18n";

export default {
  namespaced: true,
  state: {
    statuses: {
      new: {
        text: i18n.t("shipment.status.new"),
        color: "yellow",
        value: "new",
      },
      pending: {
        text: i18n.t("shipment.status.pending"),
        color: "orange",
        value: "pending",
      },
      processed: {
        text: i18n.t("shipment.status.processed"),
        color: "blue",
        value: "processed",
      },
      ready: {
        text: i18n.t("shipment.status.ready"),
        color: "violet",
        value: "ready",
      },
      shipped: {
        text: i18n.t("shipment.status.shipped"),
        color: "green",
        value: "shipped",
      },
      canceled: {
        text: i18n.t("shipment.status.canceled"),
        color: "red",
        value: "canceled",
      },
    },
    types: {
      selfPickup: {
        text: i18n.t("label.delivery.formStorage"),
        value: "selfPickup",
      },
      atmosfera: {
        text: i18n.t("label.delivery.companyLogistics"),
        value: "atmosfera",
      },
      novaPost: {
        text: i18n.t("label.delivery.formNovaPost"),
        value: "novaPost",
      },
      delivery: {
        text: i18n.t("label.delivery.formDelivery"),
        value: "delivery",
      },
    },
    storages: [],
    filtersForm: null,
  },
  getters: {
    getType(state) {
      return (type) => {
        return state.types[type];
      };
    },
    getStatus(state) {
      return (status) => {
        return state.statuses[status];
      };
    },
    getShipmentStatuses(state) {
      return Object.values(state.statuses);
    },
    getShipmentTypes(state) {
      return Object.values(state.types);
    },
    getFiltersOption() {
      return (column, value) => {
        const columns = ["status", "customerId"];
        const operator = columns.includes(column) ? "" : "like";

        const option = {
          method: "where",
          column,
          operator,
          value,
        };

        if (column === "customerId") {
          option.relation = "company";
          option.column = "customerId";
        }

        return option;
      };
    },

    getFiltersOptions(state, getters) {
      return () => {
        const filtersForm = state.filtersForm;
        let filtersOptions = [];

        if (filtersForm) {
          Object.keys(filtersForm).forEach((key) => {
            if (filtersForm[key] && key !== "date" && key !== "amount") {
              const column = key;
              const value = filtersForm[key];

              filtersOptions.push(getters.getFiltersOption(column, value));
            }
          });

          if (Object.values(filtersForm.date).length) {
            filtersOptions.unshift({
              method: "where",
              column: "documentDate",
              operator: "date>=",
              value: filtersForm.date.from.toString(),
            });

            filtersOptions.unshift({
              method: "where",
              column: "documentDate",
              operator: "date<=",
              value: filtersForm.date.to.toString(),
            });
          }

          if (filtersForm.amount.from) {
            filtersOptions.unshift({
              method: "where",
              column: "amount",
              operator: ">=",
              value: filtersForm.amount.from,
            });
          }

          if (filtersForm.amount.to) {
            filtersOptions.unshift({
              method: "where",
              column: "amount",
              operator: "<=",
              value: filtersForm.amount.to,
            });
          }
        }

        return filtersOptions;
      };
    },
  },
  mutations: {
    SET_STORAGES(state, storages) {
      state.storages = storages;
    },
    SET_FILTERS_FORM(state, form) {
      state.filtersForm = form;
    },
  },
};
